import { HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpErrorStrategy } from '../../core/http/base-error.strategy';

export interface RequestOptions {
  params?: HttpParams;
  headers?: HttpHeaders;
  context?: HttpContext;
  retries?: number;
  errorStrategy?: HttpErrorStrategy;
}
